import RcDomainMap from "../../../common/RcDomainMap.js";
import SortUtils from "../../SortUtils.js";
import GpsPosition from './GpsPosition.js';
import RcTime from "../../../session/time/RcTime.js";

export default class GpsPositionMap extends RcDomainMap {
  static MODEL_NAME = GpsPosition.MODEL_NAME + "Map";

  constructor(domain, data) {
    super(domain, data, GpsPositionMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new GpsPositionMap(this.domain, data);
  }

  find() {
    var keys = this.keys();
    var found = new GpsPositionMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.gpsPositions().findById(key);
      var item = new GpsPosition(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }

  sort(time = null, endOfDay = true) {
    let endOfDayTime = time;
    if (endOfDay) {
      let date = RcTime.time().at(parseInt(time));
      endOfDayTime = date.day().lastHour().time();
    }
    let sortedList = this.list().sort(SortUtils.SortBy_createdDateZa);
    let forTime = sortedList;
    if (time != null) {
      forTime = [];
      for (let index in sortedList) {
        let position = sortedList[index];
        if (position.date().time() < endOfDayTime) {
          forTime.push(position);
        }
      }
    }
    return forTime;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getGpsPosition(key);
      values.push(item);
    }
    return values;
  }

  first() {
    var all = this.list();
    if (all.length > 0) {
      return all[0];
    }
    return new GpsPosition(this.domain);
  }

  getGpsPosition(key) {
    var value = super.get(key);
    return new GpsPosition(this.domain, value);
  }

  addGpsPosition(item) {
    this.add(item).done();
    return this;
  }
}
